<template>
    <kgr-loading
        v-if="loading"
        :inline="true"
    />
    <select
        v-else
        :id="id"
        v-model="model"
        class="kgr-select"
    >
        <option
            :value="null"
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>

        <option
            v-for="option in options"
            :key="option.id"
            :value="option"
            class="kgr-select__option"
        >
            {{ option.value }}
        </option>
    </select>
</template>

<script setup>
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import ClubRepository from '../../../js/repository/ClubRepository';
import KgrLoading from '../../common/Loading.vue';
import ParameterValue from '../../../js/dto/ParameterValue';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps({
    clubId: {
        type: Number,
        required: true,
    },
});

const model = defineModel({
    type: ParameterValue,
    required: false,
});

const { proxy } = getCurrentInstance();
const options = ref([]);
const loading = ref(true);

const id = computed(() => `kgr-club-employee-role-select-club-${props.clubId}`);

onMounted(() => {
    ClubRepository.findEmployeeRoles(props.clubId)
        .then((employeeRoles) => {
            options.value = employeeRoles;
            loading.value = false;
        })
        .catch(() => proxy.$notify.error('error.loadingData'));
});
</script>
